import React from "react";

import Traductor from "../../Traductor";

const ManagementFiltersFooter = ({ onClose, onSubmit }) => {
  const t = new Traductor();
  return (
    <div className="c-modal__footer u-ph">
      <div className="c-modal__actions">
        <div
          className="c-modal__actions__item o-button-container u-flex u-ml-none u-mb-small"
          style={{ flexBasis: "initial" }}
        >
          <button
            className="c-btn o-button-container__button c-btn--secondary js-modal-close  js-modal-autofocus"
            aria-label="Close modal"
            onClick={onClose}
          >
            <span className="c-btn__text">{t.getTraduction("Cancelar")}</span>
          </button>
          <button
            className="c-btn o-button-container__button js-modal-close  js-modal-autofocus"
            aria-label="Close modal and save changes"
            onClick={onSubmit}
            type="submit"
          >
            <span className="c-btn__text">{t.getTraduction("Apply")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManagementFiltersFooter;
